import React from 'react';

import './ProductOverview.scss';
import sendEvent from '../../helpers/tracking';

export default function ProductOverview({
  product, NextLink, returnTo
}) {
  return (
    <NextLink href={`${product.uri}/${product.id}`}>
      <div className="productOverview">
        <h2 className="productOverview-title">
          {product.title}
        </h2>

        <ul className="productOverview-list">
          {product.benefits.map((item, idx) =>
            <li key={idx}>
              <span
                className="productOverview-list-item-marker">
                {idx + 1}
               </span>
              <p className="productOverview-list-item-text">{item}</p>
            </li>)}
        </ul>

        <button
          className="productOverview-button productOverview-button-primary"
          onClick={() => {
            sendEvent(...product.orderButtonTracking);

            location.href =
              `/form-answers/create/${product.formXuid}/anonymous?alternativeView=true&returnTo=${returnTo}`
          }}
        >
          Bestellen
        </button>
      </div>
    </NextLink>
  );
}
